<template>
  <div class="row-info" :class="column ? 'row-info--column' : 'row-info--row'">
    <div class="key">
      <slot name="label">{{ $t(label) }}</slot>
    </div>
    <div :class="['value', valueClass]">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    column: {
      type: Boolean,
      default: false
    },
    valueClass: String
  }
}
</script>

<style lang="scss" scoped>
.row-info {
  display: flex;
  font-size: 14px;
  &:not(:last-child) {
    margin-bottom: 10px;
  }
  .key {
    color: var(--font-color-3);
  }
  .value {
    color: var(--font-color-1);
    word-break: break-all;
  }
}
.row-info--row {
  &:not(:last-child) {
    margin-bottom: 10px;
  }
  .key {
    white-space: nowrap;
    margin-right: 10px;
  }
  .value {
    flex: 1;
    text-align: right;
  }
}
.row-info--column {
  flex-direction: column;
  .key {
    margin-bottom: 5px;
  }
}
</style>
